import { motion } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import css from './Nodes.module.css';

export default function DigramNode({ id, children, className }) {
  const classes = cn(css.node, className);

  return (
    <motion.div id={`node-${id}`} className={classes}>
      {children}
    </motion.div>
  );
}
